/**
 * The fill stays a hand-written var() rather than a style prop, because
 * createIcon puts this <svg> inside another one and Chakra styles only the
 * outer element. The name is the only thing that changes: jaen's system emits
 * --jaen-*, and CMS routes mount that system alone, so --chakra-colors-pink-500
 * resolved against nothing there. `fill` is an inherited property, so the
 * unresolvable value did not fall back to the v2 pink but to whatever the
 * ancestors carried, i.e. black.
 */
import {createIcon} from '@chakra-ui/react'

export const JaenLogo = createIcon({
  displayName: 'JaenLogo',
  viewBox: '0 0 512 512',
  path: (
    <svg
      fill="var(--jaen-colors-pink-500)"
      version="1.1"
      id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 475 475"
      xmlSpace="preserve">
      <style type="text/css">
        {`.st0{fill-rule:evenodd;clip-rule:evenodd;}
   .st1{fill:#FFFFFF;}
   .st2{fill:none;}
   .st3{fill:#C1C1C1;}`}
      </style>
      <g id="layer1" transform="translate(-41.732056,-64.283038)">
        <path
          id="Fill_1"
          className="st0"
          d="M467,114.2c-44.8-44.6-109.2-49.6-187.9-49.6c-78.8,0-143.2,5-188,49.8S41.8,223.5,41.8,302.2
     S46.3,445.3,91.1,490s109.2,49.3,188,49.3s143.2-4.5,188-49.3s49.3-109.1,49.3-187.9C516.5,223.4,511.9,158.9,467,114.2L467,114.2z
     "
        />
      </g>
      <path
        className="st1"
        d="M115.9,344.8c6.1,2.2,9.4,5.7,12.9,8.7c29.6,24.4,63.4,38.9,101.9,39.7c72.8,1.6,136.2-46.3,149.9-117.8
   c11.6-60.2-8.1-110.1-58-145.8c-60.1-43-143.5-29.9-188,28.6c-29.3,38.5-35.7,81.5-20.3,127.4c3.6,10.9,3.8,20.7-3.6,29.9
   c-6.3,7.8-14.7,10.8-24.5,9.5c-11-1.5-18.5-7.9-22.1-18.3c-5.3-15.4-8.9-31.3-9.8-47.5C51,199.9,70,148.8,114,108.6
   c39.7-36.4,87.2-52.9,141.3-47.5c80.5,8.1,144.1,64.6,159.8,142.9c19.4,96.8-40.6,189-136.9,207c-60.2,11.2-113.3-5.1-154.4-53
   c-2.1-2.5-3.8-5.4-5.6-8.1C117.5,348.7,117.1,347.4,115.9,344.8L115.9,344.8z"
      />
      <g transform="translate(0.000000,860.000000) scale(0.100000,-0.100000)">
        <path
          className="st1"
          d="M2046.4,5333.6c118,107.8,236.6,168.3,394.4,201.2c84.8,17.4,162.4,25.5,301.2,30.1c56.2,2.2,102.8,4,103.1,4
     c0.3,0.3,5.6,23.3,11.8,51.2c54,243.1,175.5,656.2,323,1096.2c17.7,53.7,32,98.1,31.7,98.4c-0.6,0.6-144.4-142.5-319.5-318
     l-318.9-318.9l5.3-19.3c13.7-52.2-19.9-114.9-76.1-141.6c-19.9-9.3-23.3-9.9-55.6-9.9c-33.2,0-34.8,0.3-57.8,11.8
     c-83.8,41.3-101.9,148.4-36.3,214.3c32.3,32.3,77,46,117.7,36.3l16.1-4l318,318c174.8,174.8,317.4,318,317.1,318.6
     c-0.6,0.3-60.2-18.9-132.6-42.9c-450.9-148.4-832.5-260.5-1052.7-308.7c-28.3-6.2-53.4-11.8-56.2-12.7c-4.3-1.2-5.3-12.7-6.8-93.8
     c-6.8-334.8-66.1-521.7-219.9-693.1l-28.6-31.7l201.5-201.2l201.5-201.5L2046.4,5333.6z"
        />
      </g>
    </svg>
  )
})

export const JaenFullLogo = createIcon({
  displayName: 'JaenFullLogo',
  viewBox: '0 0 1112 475',
  path: (
    <svg
      fill="var(--jaen-colors-pink-500)"
      version="1.1"
      id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1112 475"
      enableBackground="new 0 0 1112 475;"
      xmlSpace="preserve">
      <style type="text/css">
        {`.st0{fill-rule:evenodd;clip-rule:evenodd;}
.st1{fill:#FFFFFF;}
.st2{fill:none;}
.st3{fill:#C1C1C1;}`}
      </style>
      <g id="layer1" transform="translate(-41.732056,-64.283038)">
        <path
          id="Fill_1"
          className="st0"
          d="M467,114.2c-44.8-44.6-109.2-49.6-187.9-49.6c-78.8,0-143.2,5-188,49.8S41.8,223.5,41.8,302.2
S46.3,445.3,91.1,490s109.2,49.3,188,49.3s143.2-4.5,188-49.3s49.3-109.1,49.3-187.9C516.5,223.4,511.9,158.9,467,114.2L467,114.2z
"
        />
      </g>
      <path
        className="st1"
        d="M115.9,344.8c6.1,2.2,9.4,5.7,12.9,8.7c29.6,24.4,63.4,38.9,101.9,39.7c72.8,1.6,136.2-46.3,149.9-117.8
c11.6-60.2-8.1-110.1-58-145.8c-60.1-43-143.5-29.9-188,28.6c-29.3,38.5-35.7,81.5-20.3,127.4c3.6,10.9,3.8,20.7-3.6,29.9
c-6.3,7.8-14.7,10.8-24.5,9.5c-11-1.5-18.5-7.9-22.1-18.3c-5.3-15.4-8.9-31.3-9.8-47.5C51,199.9,70,148.8,114,108.6
c39.7-36.4,87.2-52.9,141.3-47.5c80.5,8.1,144.1,64.6,159.8,142.9c19.4,96.8-40.6,189-136.9,207c-60.2,11.2-113.3-5.1-154.4-53
c-2.1-2.5-3.8-5.4-5.6-8.1C117.5,348.7,117.1,347.4,115.9,344.8L115.9,344.8z"
      />
      <g>
        <rect
          x="542.8"
          y="132.9"
          className="st2"
          width="582.2"
          height="209.3"
        />
        <path
          className="st3"
          d="M542.8,366.5c11.2,0,17.4-7.9,17.4-23.2V194.9h32.7v151.5c0,31.8-17.7,49.7-47.7,49.7c-2.6,0-5.9,0-9.7-0.6
l2.6-29.7C539.9,366.2,541.3,366.5,542.8,366.5z M597.5,149c0,11.8-9.7,21.2-21.2,21.2s-20.9-9.4-20.9-21.2
c0-11.2,9.4-20.9,20.9-20.9S597.5,137.9,597.5,149z"
        />
        <path
          className="st3"
          d="M772.9,194.9v143.9h-33v-25.3c-10.3,17.9-28,28.2-50.9,28.2c-38.3,0-68.9-33.5-68.9-75
c0-41.5,30.6-74.7,68.9-74.7c23,0,40.6,10.3,50.9,28.2v-25.3H772.9z M739.9,266.7c0-24.7-18.8-43.5-43.8-43.5
c-24.4,0-43.8,19.4-43.8,43.5c0,24.4,19.4,43.8,43.8,43.8C721.1,310.6,739.9,291.7,739.9,266.7z"
        />
        <path
          className="st3"
          d="M942.4,274.7H832.9c3.5,23.2,19.4,37.4,42.7,37.4c16.2,0,30.9-7.1,37.7-18.2l26.2,16.8
c-10.6,19.4-34.7,31.2-64.4,31.2c-41.5,0-74.7-32.7-74.7-75.6c0-41.8,32.7-74.1,74.1-74.1c38.8,0,69.1,30,69.1,68.6
C943.5,264.4,943.2,270.3,942.4,274.7z M909.1,249.7c-1.8-17.9-16.8-30.6-36.5-30.6s-33.5,11.8-38.5,30.6H909.1z"
        />
        <path
          className="st3"
          d="M1106.8,256.7v82.1h-33v-78c0-22.7-13.8-37.4-34.7-37.4c-21.5,0-35.6,14.7-35.6,37.4v78h-32.7V194.9h32.7v22.7
c9.1-16.2,24.4-25.6,43.5-25.6C1083.9,192,1106.8,216.7,1106.8,256.7z"
        />
      </g>
      <g transform="translate(0.000000,860.000000) scale(0.100000,-0.100000)">
        <path
          className="st1"
          d="M2046.4,5333.6c118,107.8,236.6,168.3,394.4,201.2c84.8,17.4,162.4,25.5,301.2,30.1c56.2,2.2,102.8,4,103.1,4
c0.3,0.3,5.6,23.3,11.8,51.2c54,243.1,175.5,656.2,323,1096.2c17.7,53.7,32,98.1,31.7,98.4c-0.6,0.6-144.4-142.5-319.5-318
l-318.9-318.9l5.3-19.3c13.7-52.2-19.9-114.9-76.1-141.6c-19.9-9.3-23.3-9.9-55.6-9.9c-33.2,0-34.8,0.3-57.8,11.8
c-83.8,41.3-101.9,148.4-36.3,214.3c32.3,32.3,77,46,117.7,36.3l16.1-4l318,318c174.8,174.8,317.4,318,317.1,318.6
c-0.6,0.3-60.2-18.9-132.6-42.9c-450.9-148.4-832.5-260.5-1052.7-308.7c-28.3-6.2-53.4-11.8-56.2-12.7c-4.3-1.2-5.3-12.7-6.8-93.8
c-6.8-334.8-66.1-521.7-219.9-693.1l-28.6-31.7l201.5-201.2l201.5-201.5L2046.4,5333.6z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  )
})

export const JaenFullLogoWhite = createIcon({
  displayName: 'JaenFullLogoWhite',
  viewBox: '0 0 512 512',
  path: (
    <svg
      version="1.1"
      id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1112 475"
      enableBackground="new 0 0 1112 475"
      xmlSpace="preserve">
      <style type="text/css">
        {` .st0{fill:#FFFFFF;}
 .st1{fill:none;}`}
      </style>
      <g>
        <path
          className="st0"
          d="M542.8,366.5c11.2,0,17.4-7.9,17.4-23.2V194.9h32.7v151.5c0,31.8-17.7,49.7-47.7,49.7c-2.6,0-5.9,0-9.7-0.6
   l2.6-29.7C539.9,366.2,541.3,366.5,542.8,366.5z M597.5,149c0,11.8-9.7,21.2-21.2,21.2s-20.9-9.4-20.9-21.2
   c0-11.2,9.4-20.9,20.9-20.9S597.5,137.9,597.5,149z"
        />
        <path
          className="st0"
          d="M772.9,194.9v143.9h-33v-25.3c-10.3,17.9-28,28.2-50.9,28.2c-38.3,0-68.9-33.5-68.9-75S650.7,192,689,192
   c23,0,40.6,10.3,50.9,28.2v-25.3L772.9,194.9L772.9,194.9z M739.9,266.7c0-24.7-18.8-43.5-43.8-43.5c-24.4,0-43.8,19.4-43.8,43.5
   c0,24.4,19.4,43.8,43.8,43.8C721.1,310.6,739.9,291.7,739.9,266.7z"
        />
        <path
          className="st0"
          d="M942.4,274.7H832.9c3.5,23.2,19.4,37.4,42.7,37.4c16.2,0,30.9-7.1,37.7-18.2l26.2,16.8
   c-10.6,19.4-34.7,31.2-64.4,31.2c-41.5,0-74.7-32.7-74.7-75.6c0-41.8,32.7-74.1,74.1-74.1c38.8,0,69.1,30,69.1,68.6
   C943.5,264.4,943.2,270.3,942.4,274.7z M909.1,249.7c-1.8-17.9-16.8-30.6-36.5-30.6s-33.5,11.8-38.5,30.6H909.1z"
        />
        <path
          className="st0"
          d="M1106.8,256.7v82.1h-33v-78c0-22.7-13.8-37.4-34.7-37.4c-21.5,0-35.6,14.7-35.6,37.4v78h-32.7V194.9h32.7v22.7
   c9.1-16.2,24.4-25.6,43.5-25.6C1083.9,192,1106.8,216.7,1106.8,256.7z"
        />
      </g>
      <g>
        <path
          className="st1"
          d="M255.3,61.1c-54.1-5.4-101.6,11.1-141.3,47.5c-44,40.2-63,91.3-59.7,150.6c0.9,16.2,4.5,32.1,9.8,47.5
   c3.6,10.4,11.1,16.8,22.1,18.3c9.8,1.3,18.2-1.7,24.5-9.5c7.4-9.2,7.2-19,3.6-29.9c-15.4-45.9-9-88.9,20.3-127.4
   c44.5-58.5,127.9-71.6,188-28.6c49.9,35.7,69.6,85.6,58,145.8c-13.7,71.5-77.1,119.4-149.9,117.8c-38.5-0.8-72.3-15.3-101.9-39.7
   c-3.5-3-6.8-6.5-12.9-8.7c1.2,2.6,1.6,3.9,2.3,5.1c1.8,2.7,3.5,5.6,5.6,8.1c41.1,47.9,94.2,64.2,154.4,53
   c96.3-18,156.3-110.2,136.9-207C399.4,125.7,335.8,69.2,255.3,61.1z"
        />
        <path
          className="st0"
          d="M425.3,49.9C380.5,5.3,316.1,0.3,237.4,0.3c-78.8,0-143.2,5-188,49.8C4.6,94.9,0.1,159.2,0.1,237.9
   S4.6,381,49.4,425.7c44.8,44.7,109.2,49.3,188,49.3s143.2-4.5,188-49.3c44.8-44.8,49.3-109.1,49.3-187.9
   C474.8,159.1,470.2,94.6,425.3,49.9z M278.2,411c-60.2,11.2-113.3-5.1-154.4-53c-2.1-2.5-3.8-5.4-5.6-8.1c-0.7-1.2-1.1-2.5-2.3-5.1
   c6.1,2.2,9.4,5.7,12.9,8.7c29.6,24.4,63.4,38.9,101.9,39.7c72.8,1.6,136.2-46.3,149.9-117.8c11.6-60.2-8.1-110.1-58-145.8
   c-60.1-43-143.5-29.9-188,28.6c-29.3,38.5-35.7,81.5-20.3,127.4c3.6,10.9,3.8,20.7-3.6,29.9c-6.3,7.8-14.7,10.8-24.5,9.5
   c-11-1.5-18.5-7.9-22.1-18.3c-5.3-15.4-8.9-31.3-9.8-47.5C51,199.9,70,148.8,114,108.6c39.7-36.4,87.2-52.9,141.3-47.5
   c80.5,8.1,144.1,64.6,159.8,142.9C434.5,300.8,374.5,393,278.2,411z M238.9,258.1c2.3,1.1,2.5,1.2,5.8,1.2c3.2,0,3.6-0.1,5.6-1
   c5.6-2.7,9-8.9,7.6-14.2l-0.5-1.9l31.9-31.9c17.5-17.5,31.9-31.9,32-31.8c0,0-1.4,4.5-3.2,9.8c-14.8,44-26.9,85.3-32.3,109.6
   c-0.6,2.8-1.1,5.1-1.2,5.1c0,0-4.7,0.2-10.3,0.4c-13.9,0.5-21.6,1.3-30.1,3c-15.8,3.3-27.6,9.3-39.4,20.1l-1.9,1.7l-20.2-20.1
   l-20.2-20.1l2.9-3.2c15.4-17.1,21.3-35.8,22-69.3c0.1-8.1,0.2-9.3,0.7-9.4c0.3-0.1,2.8-0.7,5.6-1.3c22-4.8,60.2-16,105.3-30.9
   c7.2-2.4,13.2-4.3,13.3-4.3c0,0.1-14.2,14.4-31.7,31.9l-31.8,31.8l-1.6-0.4c-4.1-1-8.5,0.4-11.8,3.6
   C228.7,243.3,230.5,254,238.9,258.1z"
        />
      </g>
    </svg>
  )
})
